import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../css/LandingPage.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

// import appImage1 from '../../assets/HomescreenPhone.png';
// import appImage2 from '../../assets/ChoiceScreenPhone.png';
// import appImage3 from '../../assets/ViewChoicePhone.png';

const LandingPage = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
            offset: 0,
            anchorPlacement: 'top-bottom',
        });
    }, []);



    return (
        <div className="landing-page">
            <section className="hero">
                {/*<img data-aos="fade-up" data-aos-delay="200" src={appImage1} alt="appImage1" className="appImage top-left" />*/}
                {/*<img data-aos="fade-up" data-aos-delay="200" src={appImage2} alt="appImage2" className="appImage bottom-right" />*/}
                <h1 data-aos="fade-up">Empower Communication for</h1>
                <h1 data-aos="fade-up">Non-Verbal Autistic Children</h1>
                <p data-aos="fade-up" data-aos-delay="200">Simplify Daily Transitions and Enhance Learning with CueCumber</p>
                <div data-aos="fade-up" data-aos-delay="400">
                    <Link to="/contact" className="cta-button">Get Started</Link>
                </div>
            </section>

            <section className="key-features">

                <h2 data-aos="fade-up">Key Features</h2>
                <div className="features-container">
                    <Feature
                        icon="fas fa-images"
                        title="Visual Communication"
                        description="Take photos, or use other images to communicate choices and intentions"
                    />
                    <Feature
                        icon="fas fa-calendar-alt"
                        title="Daily Schedule"
                        description="Plan and visualize daily activities for smooth transitions"
                    />
                    <Feature
                        icon="fas fa-comments"
                        title="Feedback Recording"
                        description="Capture feedback seamlessly to track progress"
                    />
                    <Feature
                        icon="fas fa-chart-bar"
                        title="AI-Driven Insights"
                        description="Generate reports to understand behavior and adaptation"
                    />
                    <Feature
                        icon="fas fa-share-alt"
                        title="Collaboration"
                        description="Share progress with carers and family members"
                    />
                    <Feature
                        icon="fas fa-mobile-alt"
                        title="User-Friendly Interface"
                        description="Easy-to-use interface for both parents and children"
                    />
                </div>
            </section>

            <section className="how-it-works">
                <h2 data-aos="fade-up">How It Works</h2>
                <div className="steps-container">
                    <Step
                        number="1"
                        title="Customize"
                        description="Set up personalized schedules and communication aids"
                    />
                    <Step
                        number="2"
                        title="Engage"
                        description="Use the app daily to communicate and guide your child"
                    />
                    <Step
                        number="3"
                        title="Track"
                        description="Monitor progress and adapt strategies based on insights"
                    />
                </div>

            </section>

            <section className="testimonials">

                <h2 data-aos="fade-up">What Parents Are Saying</h2>
                <blockquote data-aos="fade-up" data-aos-delay="200">
                    <p>"I used CueCumber today to show her we were going swimming... she went from not understanding us and being super frustrated, to extremely excited and cooperative!!! it was a wonderful feeling"</p>
                    <cite>- K, Mother of a 4-year-old, NSW</cite>
                </blockquote>
            </section>

            <section className="cta">
                {/*<img src={appImage3} alt="appImage3" className="appImage bottom-left" data-aos="fade-up" />*/}
                <h2 data-aos="fade-up">Ready to Transform Your Child's Day?</h2>
                <Link to="/contact" className="cta-button" data-aos="fade-up" data-aos-delay="200">Get Started</Link>
            </section>

            <footer>
                <p>Contact Us: hello@cuecumber.com.au</p>
                <p><Link to="/privacy">Privacy Policy</Link> | <Link to="/terms">Terms of Service</Link></p>
                <div className="social-media">
                    <a href="#"><img src="icons/facebook.png" alt="Facebook" /></a>
                    <a href="#"><img src="icons/twitter.png" alt="Twitter" /></a>
                    <a href="#"><img src="icons/linkedin.png" alt="LinkedIn" /></a>
                </div>
            </footer>

        </div>
    );
};

const Feature = ({ icon, title, description }) => (
    <div className="feature" data-aos="fade-up">
        <i className={icon}></i>
        <h3>{title}</h3>
        <p>{description}</p>
    </div>
);

const Step = ({ number, title, description }) => (
    <div className="step" data-aos="fade-up">
        <div className="step-number">{number}</div>
        <h3>{title}</h3>
        <p>{description}</p>
    </div>
);

export default LandingPage;
